import {
  RegisterProcurementSupplierDto,
  SupplierRegistrationStatusDto,
} from "@green0meter/api-client";
import {
  UseMutateAsyncFunction,
  UseMutateFunction,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { UseFormSetError } from "react-hook-form";
import { AxiosError } from "axios";
import { useTranslation } from "react-i18next";
import _ from "lodash";

import { DOMAIN_PROCUREMENT } from "../domain";

import { procurementApi } from "@api/services";
import { RegisterProcurementSupplierFormValues } from "@components/form";

export const ACTION_REGISTER_PROCUREMENT_SUPPLIER = "REGISTER_PROCUREMENT_SUPPLIER";

/*****************
 * Public route *
 *****************/

const registerProcurementSupplier = async (
  param: RegisterProcurementSupplierDto,
): Promise<SupplierRegistrationStatusDto> => {
  const response =
    await procurementApi.procurementControllerRegisterProcurementSupplier(param);

  return response.data;
};

export const useRegisterProcurementSupplier = (
  setError?: UseFormSetError<RegisterProcurementSupplierFormValues>,
): {
  registerSupplier: UseMutateFunction<
    SupplierRegistrationStatusDto,
    AxiosError,
    RegisterProcurementSupplierDto,
    unknown
  >;
  registerSupplierAsync: UseMutateAsyncFunction<
    SupplierRegistrationStatusDto,
    AxiosError,
    RegisterProcurementSupplierDto,
    unknown
  >;
  isSuccessRegisterSupplier: boolean;
  isPendingRegisterSupplier: boolean;
  registerSupplierData?: SupplierRegistrationStatusDto;
} => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  const { mutate, isSuccess, isPending, data, mutateAsync } = useMutation({
    mutationKey: [DOMAIN_PROCUREMENT, ACTION_REGISTER_PROCUREMENT_SUPPLIER],
    mutationFn: registerProcurementSupplier,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [DOMAIN_PROCUREMENT] });
    },
    onError: (error: AxiosError) => {
      if (setError) {
        const apiError = error as {
          response?: { data?: { code?: string; message?: string | string[] } };
        };

        const messages = apiError?.response?.data?.message;
        const code = apiError?.response?.data?.code;

        if (messages) {
          if (Array.isArray(messages)) {
            messages.forEach((m: string) => {
              const fieldName = m.split(
                "_",
              )[0] as keyof RegisterProcurementSupplierFormValues;
              const errorMessage = t(`registration.${m}`);

              console.log(fieldName, errorMessage);

              setError(fieldName, {
                type: "string",
                message: errorMessage,
              });
            });
          } else {
            const fieldName = messages.split(
              "_",
            )[0] as keyof RegisterProcurementSupplierFormValues;

            const errorMessage = t(`registration.${messages}`);

            setError(fieldName, {
              type: "string",
              message: errorMessage,
            });
          }
        }

        if (code === "email_not_found_on_supplier_list") {
          setError("email", {
            message: t("validation.errors.incorrect_email"),
            type: "server",
          });
        }
      }
    },
  });

  return {
    registerSupplier: mutate,
    registerSupplierAsync: mutateAsync,
    isSuccessRegisterSupplier: isSuccess,
    isPendingRegisterSupplier: isPending,
    registerSupplierData: data,
  };
};
